<lib-filtered-table
  [tableId]="'delegation-table'"
  [tableTitle]="'delegation_tab_table_title' | transloco"
  [dataSource]="delegationTableRows()"
  [meta]="meta()"
  [totalItems]="totalItems()"
  [columns]="columns()"
  [isLoadingData]="isLoading()"
  [tableFilterTabs]="tableFilterTabs()"
  [(payload)]="payload"
  [lastColumnAlignment]="'justify-end'"
  [tableColumnTemplates]="[
    { template: number, identifier: COLUMN_IDENTIFIERS.NUMBER },
    { template: id, identifier: COLUMN_IDENTIFIERS.ID },
    { template: delegate, identifier: COLUMN_IDENTIFIERS.DELEGATE },
    { template: period, identifier: COLUMN_IDENTIFIERS.PERIOD },
    { template: tasks, identifier: COLUMN_IDENTIFIERS.TASKS },
    { template: status, identifier: COLUMN_IDENTIFIERS.STATUS },
    { template: action, identifier: COLUMN_IDENTIFIERS.ACTION },
  ]"
  [isTableExportable]="false"
  [filterOptions]="filterOptions()"
  [filterMapping]="filterMapping()"
  [tableActionSectionRef]="tableActionSectionRef"
  [searchPlaceholder]="'delegation_tab_search_input_placeholder' | transloco"
  [applyOnStreamChanges]="getDelegationList$"
  (streamSucceeds)="handleGetDelegationListSuccess($event)"
  (handleApiCall)="getDelegationList($event)"
  (handleViewIconClick)="viewDelegationDetails($event)" />

<ng-template #number let-i="i">
  @let metaData = meta();
  @if (metaData) {
    {{ (metaData.current_page - 1) * metaData.per_page + (i + 1) }}
  }
</ng-template>

<ng-template #id let-row>
  {{ row.id }}
</ng-template>

<ng-template #delegate let-row>
  @if(this.isDelegatedToMeTab()){
    <div class="flex items-center gap-md text-neutral-900">
      <lib-avatar
        [size]="'list'"
        [img]="row.delegator?.image?.url"
        [fullName]="row.delegator?.name"
        borderRadius="rounded-full" />
      <span class="text-xs font-medium">
        {{ row.delegator?.name | truncate }}
      </span>
    </div>
  }@else{
    <div class="flex items-center gap-md text-neutral-900">
      <lib-avatar
        [size]="'list'"
        [img]="row.delegate?.image?.url"
        [fullName]="row.delegate?.name"
        borderRadius="rounded-full" />
      <span class="text-xs font-medium">
        {{ row.delegate?.name | truncate }}
      </span>
    </div>
  }
 
</ng-template>

<ng-template #period let-row>
  <span dir="ltr">
    {{
      (row.started_at | date: 'dd-MMM-yyyy') +
        '  :  ' +
        (row.ended_at | date: 'dd-MMM-yyyy')
    }}
  </span>
</ng-template>

<ng-template #tasks let-row>
  {{ row.flow_templates.length }}
</ng-template>

<ng-template #status let-row>
  <lib-badge
    [label]="row.state.label"
    [badgeClass]="
      'px-sm border-none text-xs font-medium text-white ' +
      (row.statusBadgeClass ?? '')
    " />
</ng-template>

<ng-template #action let-row>
  <lib-action-list
    [parentName]="'delegation-table'"
    [menuItems]="row.actionMenuItems"
    (itemClick)="onActionClick($event, row)" />
</ng-template>

<ng-template #viewDetails let-row>
  <button
    type="button"
    class="text-primary-500"
    (click)="viewDelegationDetails(row)">
    {{ 'delegation_tab_view_details' | transloco }}
  </button>
</ng-template>

<ng-template #tableActionSectionRef>
  <a
    [routerLink]="[`/${EMPLOYEE_ROUTES.ACCOUNT_SETTINGS.DELEGATION_FORM}`]"
    id="delegation_tab_new_delegation_button"
    class="flex justify-center items-center gap-sm bg-primary-500 text-white text-sm font-medium py-sm px-lg rounded-sm">
    <lib-add-icon [iconClass]="'size-5 text-white'" />

    {{ 'delegation_tab_add_delegation_button' | transloco }}
  </a>
</ng-template>

<ng-template #cancelDelegationModal>
  <lib-confirmation-popup
    [title]="'delegation_tab_cancel_modal_title' | transloco"
    [description]="'delegation_tab_cancel_modal_description' | transloco"
    [confirmButton]="{
      label: 'delegation_tab_cancel_modal_confirm_button' | transloco,
      action: confirmCancelDelegation,
    }"
    [cancelButton]="'delegation_tab_cancel_modal_keep_button' | transloco"
    [status]="'error'"
    [disable]="isActionLoading()" />
</ng-template>

<ng-template #revokeDelegationModal>
  <lib-confirmation-popup
    [title]="'delegation_tab_revoke_modal_title' | transloco"
    [description]="'delegation_tab_revoke_modal_description' | transloco"
    [confirmButton]="{
      label: 'delegation_tab_revoke_modal_confirm_button' | transloco,
      action: confirmRevokeDelegation,
    }"
    [cancelButton]="'delegation_tab_revoke_modal_keep_button' | transloco"
    [status]="'error'"
    [disable]="isActionLoading()" />
</ng-template>
